var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.rental.title", {
    count: _vm.report.rentals.length
  })) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        _vm.createDialog = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.rental.add")) + " ")])], 1), _vm.report.isRentalsLoading ? _c('v-skeleton-loader', {
    staticClass: "mx-4 mb-4",
    attrs: {
      "type": "image"
    }
  }) : _vm.report.rentals.length === 0 ? _c('v-card-text', [_c('m-no-content', {
    attrs: {
      "icon": "mdi-file-document-outline",
      "text": _vm.$t('components.PartnerReportDetail.rental.missing')
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('v-btn', {
          staticClass: "mx-2 px-4",
          attrs: {
            "elevation": "0"
          },
          on: {
            "click": function click($event) {
              _vm.createDialog = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-tray-arrow-up")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.rental.add")) + " ")], 1)];
      },
      proxy: true
    }])
  })], 1) : _c('div', {
    staticClass: "mx-4"
  }, [_c('v-divider'), _c('v-tabs', {
    staticClass: "custom-tabs",
    attrs: {
      "background-color": "transparent",
      "show-arrows": "",
      "slider-color": "transparent",
      "active-class": "custom-tab--active"
    },
    model: {
      value: _vm.activeRental,
      callback: function callback($$v) {
        _vm.activeRental = $$v;
      },
      expression: "activeRental"
    }
  }, _vm._l(_vm.report.rentals, function (rental, index) {
    var _rental$timestamp;

    return _c('v-tab', {
      key: 'tab-' + index,
      attrs: {
        "value": index
      }
    }, [_vm._v(" " + _vm._s(rental.title + ((_rental$timestamp = rental.timestamp) !== null && _rental$timestamp !== void 0 && _rental$timestamp.createdReadable ? " (" + rental.timestamp.createdReadable + ")" : "")) + " ")]);
  }), 1), _c('v-sheet', {
    attrs: {
      "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    }
  }, [_c('v-card-text', [_c('v-tabs-items', {
    model: {
      value: _vm.activeRental,
      callback: function callback($$v) {
        _vm.activeRental = $$v;
      },
      expression: "activeRental"
    }
  }, _vm._l(_vm.report.rentals, function (rental, index) {
    return _c('v-tab-item', {
      key: 'tab-content-rental' + index,
      attrs: {
        "value": index
      }
    }, [_c('rental-sheet', {
      attrs: {
        "rental": rental
      },
      on: {
        "deleted": function deleted($event) {
          return _vm.removeFromReport(rental);
        }
      }
    })], 1);
  }), 1)], 1)], 1)], 1), _c('report-rental-create-dialog', {
    model: {
      value: _vm.createDialog,
      callback: function callback($$v) {
        _vm.createDialog = $$v;
      },
      expression: "createDialog"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }